/**
 * 错误页配置
 */
export default {
  configData: {
    showNewsTag: false, // 是否显示信息流标签
    showComps: [
      'SearchBar', 'HotWords', 'LeftNews', 'RightNews'
    ], // 需要显示的组件
    LeftNews: {
      newsList: {
        type: 'df',
        params: {
          qid: '2345xxxl'
        },
        click_report: 'Error_Click_News'
      },
      ad: {
        type: 'bdwm',
        uuid: [
          'u4804548', // 大图
          // 'u4804554' // 小图
        ],
        show_report: 'Error_AdShow_Baidu'
        // type: '360',
        // uuid: ['Anu5u2'],
        // show_report: 'Error_AdShow_360',
        // click_report: 'Error_AdClick_360'
      }
    }, // 左侧信息流相关配置
    RightNews: {
      EntNews: {
        newsList: {
          type: 'df',
          params: {
            qid: '2345error'
          },
          click_report: 'Error_Click_News_Right'
        },
        ad: {
          type: 'bdwm',
          uuid: ['u4804554'],
          show_report: 'Error_AdShow_Baidu_Right',
          // type: '360',
          // uuid: ['2tHbKY'],
          // show_report: 'Error_AdShow_360_Right',
          // click_report: 'Error_AdClick_360_Right'
        }
      },
      AdsChuChuang: {
        show: true
      }
    } // 右侧信息流相关配置
  },
  /**
   * 获取相关配置
   * @param cfgName 配置key
   * @returns {*|undefined}
   */
  getCfg (cfgName) {
    let srcData = arguments[1] || this.configData;
    return srcData[cfgName] || undefined;
  }
}
